import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Select from 'react-select';
import {baseUrl } from "../../comman/config";
import { useLocation } from 'react-router-dom';
import { menuAboveTable } from "../../comman/selectMenu";

// `compact` puts Date, Session and Submit on ONE line and keeps them there at phone width,
// instead of the default layout's generous m-5 margins that wrap them onto three lines. Opt-in
// rather than the new default: nineteen other screens use this filter on desks where the roomier
// version is the better one, and this is for the screens meant to be worked on a phone.
const DateSessionFilter = ({ handleFilterChange, compact = false }) => {
    const today = new Date().toISOString().split('T')[0];
    const [date, setDate] = useState(today);
    const [session, setSession] = useState("");
    const [method, setMethod] = useState([]);
    const [sessionList, setSessionList] = useState([]);
    const [methodList, setMethodList] = useState([]);
    const location = useLocation();
    const routeName = location.pathname
    useEffect(() => {
    const storedDate = sessionStorage.getItem('selectedDate');
    const storedSession = sessionStorage.getItem('selectedSession');

    const clearSessionAfterOneHour = () => {
        sessionStorage.removeItem('selectedDate');
        sessionStorage.removeItem('selectedSession');
      };
    if(storedDate && storedSession){
      const parsedSession = JSON.parse(storedSession);
      setDate(storedDate);
      setSession(parsedSession);
      handleFilterChange(storedDate, parsedSession);
    }

    setTimeout(clearSessionAfterOneHour, 3600 * 1000);
   
  }, []);
    useEffect(() => {
        getSessionList();
        getMethodList()
    }, []);

    const getSessionList =  async () => {
        const response = await axios.get(`${baseUrl}/comman/list?table=session_master&condition=status=1`,
            { headers: { 'Cache-Control': 'no-cache' } }
        );
        setSessionList(response.data.data);
    }

    const getMethodList = async () => {
        const response = await axios.get(
          `${baseUrl}/comman/list?table=method_master&condition=status=1`
        );
        setMethodList(response.data.data);
      };

    const handleDateChange = (e) => {
        setDate(e.target.value);
    };

    const handleSelectChange = (data, option) => {
        setSession(data);
    };

    const handleChangeMultiSelect = (selected, name) => {
        if(name === 'method'){
            setMethod(selected);
        }
    };

    const handleSubmit = () => {
        // Handle submit logic here
        // You can pass date and session values to the parent component using handleFilterChange
        sessionStorage.setItem('selectedDate', date);
    sessionStorage.setItem('selectedSession', JSON.stringify(session));
        handleFilterChange(date, session, method);
    };

    return (
        <div className={compact
            ? "py-2 px-2 flex flex-nowrap items-center gap-2"
            : "pb-4 flex flex-column sm:flex-row flex-wrap space-y-4 sm:space-y-0 items-center"}>
            <div className={compact ? 'shrink min-w-0' : 'm-5'}>
                <input
                    type="date"
                    className={`block ${compact ? 'w-full p-1.5 text-xs' : 'p-2 text-sm'} text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500`}
                    onChange={handleDateChange}
                    value={date}
                />
            </div>
            {/* The one that gives: a session name is short, so it takes what the date and the
                button leave rather than a width of its own. */}
            <div className={compact ? 'flex-1 min-w-0' : 'm-5'}>
                {/* <select
                    className="block p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    onChange={handleSessionChange}
                    value={session}
                >
                    <option value="">Select Session</option>
                    
                </select> */}
                <Select
                    {...menuAboveTable}
                    classNamePrefix="select"
                    value={session}
                    name="session"
                    onChange={(selectedOption, name) => {
                        handleSelectChange(selectedOption, name);
                    }}
                    options={sessionList.map(item => ({
                        value: item.id,
                        label: item.name
                    }))}
                    filterOption={(option, inputValue) => {
                        return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                    }}
                />  
            </div>
            {(routeName == '/finished_good/list' || routeName == '/excess_screen/list') && <div className='m-5'>
                <Select
                    {...menuAboveTable}
                    isMulti
                    classNamePrefix="select"
                    className='basic-multi-select'
                    value={method}
                    name="method"
                    onChange={(selectedOptions) => handleChangeMultiSelect(selectedOptions, 'method')}
                    options={methodList.map(item => ({
                        value: item.id,
                        label: item.name
                    }))}
                    placeholder="Method List"
                    filterOption={(option, inputValue) => {
                        return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                    }}
                />  
            </div>}
            <div className={compact ? 'shrink-0' : 'm-5'}>
                <button
                    onClick={handleSubmit}
                    className={`${compact ? 'px-3 py-1.5 text-sm' : 'px-4 py-2 mr-4'} bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200`}
                >
                    Submit
                </button>
            </div>
        </div>
    );
};

export {DateSessionFilter};
